"use client";
import React from "react";
import Layout from "./Layout";
import Link from "components/common/Link";
import ShopFeatureCard from "components/home/Card/ShopFeatureCard";
import { get } from "utils/lodash";
import { useT, useI18n } from "providers/I18nProvider";
import useRotatingTagline from "hooks/useRotatingTagline";

/**
 * Section "Địa điểm nổi bật": lưới 4 cột (2 hàng = 8 shop), ảnh gallery thật.
 * Mobile: 2 cột, cuộn dọc bình thường.
 */
const ShopSection: React.FC<{
  title: string;
  description: string;
  data: any;
  limit?: number;
}> = ({ title, description, data, limit = 8 }) => {
  const t = useT();
  const { locale } = useI18n();
  // Câu giới thiệu tự đổi mỗi 2 phút (4 biến thể trong file dịch)
  const rotatingDesc = useRotatingTagline("home.topPlacesDesc", description);
  const all = (data || []).filter((s: any) => !!get(s, "slug"));
  const shops = all.slice(0, limit);
  if (!shops.length) return null;

  return (
    <Layout
      iconName="crown"
      // CMS chỉ lưu tên tiếng Việt; khi EN luôn ưu tiên bản dịch thay vì tên CMS.
      title={locale === "en" ? t("home.topPlaces") : title || t("home.topPlaces")}
      description={rotatingDesc}
      extra={
        // "Xem tất cả" → trang riêng /dia-diem-noi-bat (có phân trang). Trước trỏ
        // /search → ra toàn bộ shop trên Lookme, sai ý nghĩa "nổi bật".
        all.length > limit ? (
          <Link
            href="/dia-diem-noi-bat"
            className="tap-area inline-flex min-h-6 items-center text-sm font-bold text-primary-ink hover:underline"
          >
            {t("home.viewAll")} →
          </Link>
        ) : null
      }
    >
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 px-4 md:px-6">
        {shops.map((shop: any) => (
          <ShopFeatureCard key={get(shop, "id")} shop={shop} />
        ))}
      </div>
    </Layout>
  );
};

export default ShopSection;
